export default "__VITE_ASSET__cdb3c656__"